export default function authHeader() {
  const STORAGE_USER = `user/${window.REACT_APP_WEB_FOLDER || ""}`;
  const user = JSON.parse(localStorage.getItem(STORAGE_USER));

  if (user && user.accessToken) {
    // for Node.js Express back-end
    return { 'x-access-token': user.accessToken };
  } else {
    return {};
  }
}
